module.exports = __webpack_public_path__ + "static/media/carbon_neutral.d0ef77bb.svg";